import { Asset } from '@/api/generatedApi';
import { Box } from '@mui/material';
import { AssetActionRow } from '../AssetActionRow';
import { LeftPanel } from '../DraggablePanel/LeftPanel';
import { AssetDetails } from './AssetDetails';
import { AssetMetadata } from './AssetMetadata';
import { DependencyTreeDetails } from './DependencyTree/DependencyTreeDetails';
import { DependencyContext } from './DependencyTree/DependencyTreeView';
import { SupplementalAssets } from './SupplementalAssets';

export const AssetSidebar = ({
  asset,
  onWidthChange,
  onTreeItemClick,
  onReprocessCriticalGeometry,
  isReprocessCriticalGeometryDisabled = false,
  highlightedAssetIds,
  highlightedNodeNames,
}: {
  asset?: Asset;
  onWidthChange?: (width: number) => void;
  onTreeItemClick?: (itemId: string, context?: DependencyContext) => void;
  onReprocessCriticalGeometry?: () => void | Promise<void>;
  isReprocessCriticalGeometryDisabled?: boolean;
  highlightedAssetIds?: string[];
  highlightedNodeNames?: string[];
}) => {
  return (
    <LeftPanel
      style={{
        position: 'relative',
      }}
      onWidthChange={onWidthChange}
    >
      <Box display='flex' flexDirection='column' height='100%'>
        <AssetActionRow
          asset={asset}
          hideAssetPageLink
          showReprocess
          onReprocessCriticalGeometry={onReprocessCriticalGeometry}
          isReprocessCriticalGeometryDisabled={isReprocessCriticalGeometryDisabled}
        />
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          <AssetDetails asset={asset} />
          <DependencyTreeDetails
            asset={asset}
            onTreeItemClick={onTreeItemClick}
            highlightedAssetIds={highlightedAssetIds}
            highlightedNodeNames={highlightedNodeNames}
          />
          <SupplementalAssets asset={asset} />
          <AssetMetadata asset={asset} />
        </Box>
      </Box>
    </LeftPanel>
  );
};
